import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ControlSubstanesIcon from "../../../images/icons/ControlSubstanesIcon.svg";
import CancelRxIcon from "../../../images/icons/CancelRxIcon.svg";
import RxFillIcon from "../../../images/icons/RxFillIcon.min.svg";
import PendingRefillsIcon from "../../../images/icons/PendingRefillsIcon.min.svg";
import EPAWorklistIcon from "../../../images/icons/EPAWorklistIcon.min.svg";
import MyAccountIcon from "../../../images/icons/MyAccountIcon.svg";
import NewRxPadIcon from "../../../images/icons/NewRxPadIcon.svg";
import PendingRxChangeIcon from "../../../images/icons/PendingRxChangeIcon.min.svg";
import { HtmlTooltip, ServiceBox, ServiceStyle } from "../../../Theme";
import { useSelector } from "react-redux";
import PdmpIcon from "../../../images/icons/PdmpIcon.svg";

export default function ServicesEnabled() {
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  return (
    <Grid
      container
      item
      xs={12}
      spacing={1}
      alignItems="top"
      justifyContent="center"
    >
      <Grid item xs={12}>
        <Typography component="div" variant="subtitle1">
          Services Enabled for you
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ServiceStyle>
          <ServiceBox
            className={UserServiceState?.newRxEnabled ? "active" : ""}
          >
            <HtmlTooltip
              className="w250"
              placement="bottom"
              arrow
              title={
                <Typography component="div" variant="body2">
                  This service level NewRx will enable prescribers to prescribe
                  the normal medications
                </Typography>
              }
            >
              <Card>
                <img src={NewRxPadIcon} alt="New Rx" loading="lazy" />
              </Card>
            </HtmlTooltip>
            <Typography component="div" variant="body2">
              New Rx
            </Typography>
          </ServiceBox>
          <ServiceBox
            className={UserServiceState?.refillEnabled ? "active" : ""}
          >
            <HtmlTooltip
              className="w250"
              placement="bottom"
              arrow
              title={
                <Typography component="div" variant="body2">
                  Upon enabling this service level, If a refill is needed for a
                  drug, the pharmacy electronically sends a refill request to
                  the physician, and the physician authorizes the prescription
                  refill.
                </Typography>
              }
            >
              <Card>
                <img src={PendingRefillsIcon} alt="Refill" loading="lazy" />
              </Card>
            </HtmlTooltip>
            <Typography component="div" variant="body2">
              Refill
            </Typography>
          </ServiceBox>
          <ServiceBox className={UserServiceState?.epcsenabled ? "active" : ""}>
            <HtmlTooltip
              className="w250"
              placement="bottom"
              arrow
              title={
                <Typography component="div" variant="body2">
                  This service level will enable the prescribers to prescribe
                  control substances electronically, DEA is must to get this
                  service level enabled and need to undergo the two factor and
                  ID proofing from ID.me
                </Typography>
              }
            >
              <Card>
                <img
                  src={ControlSubstanesIcon}
                  alt="Control Substances"
                  loading="lazy"
                />
              </Card>
            </HtmlTooltip>
            <Typography component="div" variant="body2">
              Control Substances
            </Typography>
          </ServiceBox>
          <ServiceBox
            className={UserServiceState?.cancelRxEnabled ? "active" : ""}
          >
            <HtmlTooltip
              className="w250"
              placement="bottom"
              arrow
              title={
                <Typography component="div" variant="body2">
                  CancelRx transaction communicates an electronic message to the
                  pharmacy when the provider discontinues a medication in the
                  H2H DRx system. Upon enabling this service level at H2H DRx,
                  the Providers can enter notes in that message to indicate why
                  the medication was discontinued, giving the pharmacist more
                  information to correctly complete the puzzle.
                </Typography>
              }
            >
              <Card>
                <img src={CancelRxIcon} alt="Cancel Rx" loading="lazy" />
              </Card>
            </HtmlTooltip>
            <Typography component="div" variant="body2">
              Cancel Rx
            </Typography>
          </ServiceBox>
          <ServiceBox
            className={UserServiceState?.rxFillEnabled ? "active" : ""}
          >
            <HtmlTooltip
              className="w250"
              placement="bottom"
              arrow
              title={
                <Typography component="div" variant="body2">
                  Upon enabling the “Refill” service Level, the Prescribers will
                  get notified about the status of a prescription, including
                  whether the patient picked it up or if the medication was
                  partially dispensed or never dispensed.
                </Typography>
              }
            >
              <Card>
                <img src={RxFillIcon} alt="RxFill" loading="lazy" />
              </Card>
            </HtmlTooltip>
            <Typography component="div" variant="body2">
              RxFill
            </Typography>
          </ServiceBox>
          <ServiceBox
            className={UserServiceState?.rxChangeEnabled ? "active" : ""}
          >
            <HtmlTooltip
              className="w250"
              placement="bottom"
              arrow
              title={
                <Typography component="div" variant="body2">
                  Upon enabling the Rx Change (RXCHG) service level, H2H DRx
                  will allow the pharmacy to send a message electronically to a
                  prescriber to request authorization to make a change to a
                  prescription. This is a feature that is part of a new version
                  of the electronic prescribing standard created by NCPDP.
                </Typography>
              }
            >
              <Card>
                <img src={PendingRxChangeIcon} alt="Rx Change" loading="lazy" />
              </Card>
            </HtmlTooltip>
            <Typography component="div" variant="body2">
              Rx Change
            </Typography>
          </ServiceBox>

          <ServiceBox className={UserServiceState?.epaEnabled ? "active" : ""}>
            <HtmlTooltip
              className="w250"
              placement="bottom"
              arrow
              title={
                <Typography component="div" variant="body2">
                  Electronic Prior Authorization (EPA) is the process a
                  prescriber follows to transmit a pre-authorization coverage
                  request to a payer (e.g., health plan, pharmacy benefit
                  manager) to check benefit coverage for a specific drug and
                  patient. EPA service level should be enabled at H2H DRx for
                  utilizing the EPA services.
                </Typography>
              }
            >
              <IconButton>
                <Card>
                  <img src={EPAWorklistIcon} alt="EPA" loading="lazy" />
                </Card>
              </IconButton>
            </HtmlTooltip>

            <Typography component="div" variant="body2">
              EPA
            </Typography>
          </ServiceBox>
          <ServiceBox
            className={UserServiceState?.rtfRtpbEnabled ? "active" : ""}
          >
            <HtmlTooltip
              className="w250"
              placement="bottom"
              arrow
              title={
                <Typography component="div" variant="body2">
                  <Typography
                    component="div"
                    variant="body2"
                    fontWeight={600}
                    marginBottom={1}
                  >
                    Enable this service level at H2H DRx for Real-Time Formulary
                    (RTF) & Real-Time Prescription Benefit (RTPB)
                  </Typography>
                  <Typography component="div" variant="body2" marginBottom={1}>
                    (1) Real-Time Formulary delivers formulary information to
                    the prescriber at the point of care via real time request
                    and response message. This service eliminates the need for
                    the provider vendor to download large formulary files from
                    Surescripts on a weekly basis.
                  </Typography>
                  <Typography component="div" variant="body2">
                    (2) Real-Time Prescription Benefit delivers patient-specific
                    benefit and cost information in the electronic workflow.
                    This solution empowers prescribers, pharmacists, and
                    technicians to address patient prescription cost concerns
                    and make informed decisions that boost adherence and
                    operational efficiencies.
                  </Typography>
                </Typography>
              }
            >
              <IconButton>
                <Card>
                  <img src={MyAccountIcon} alt="RTFRTPB" loading="lazy" />
                </Card>
              </IconButton>
            </HtmlTooltip>
            <Typography component="div" variant="body2">
              RTF/RTPB
            </Typography>
          </ServiceBox>
          <ServiceBox
            className={
              UserServiceState?.pdmpServiceLevels?.locationNPIAvailable &&
              UserServiceState?.pdmpServiceLevels?.stateLicenseAvailable
                ? "active"
                : ""
            }
          >
            <HtmlTooltip
              className="w250"
              placement="bottom"
              arrow
              title={
                <Typography component="div" variant="body2">
                  A Prescription Drug Monitoring Program (PDMP) is a vital tool
                  for healthcare providers, pharmacists, and law enforcement. It
                  tracks and monitors controlled substance prescriptions, aiding
                  in patient care decisions, early intervention for misuse, and
                  combating the opioid epidemic by preventing abuse and
                  diversion. PDMPs promote responsible prescribing, improving
                  patient care and public safety.
                </Typography>
              }
            >
              <Card>
                <img
                  style={{ height: 35, width: 35 }}
                  src={PdmpIcon}
                  alt="RTFRTPB"
                  loading="lazy"
                />

                {/* <PdmpIcon fontSize="large" /> */}
              </Card>
            </HtmlTooltip>
            <Typography component="div" variant="body2">
              PDMP
            </Typography>
          </ServiceBox>
        </ServiceStyle>
      </Grid>
    </Grid>
  );
}
